import React from 'react';
export default function ContentCopy(_a) {
    var className = _a.className;
    return (React.createElement("svg", { className: className, width: "1em", height: "1em", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 -960 960 960" },
        React.createElement("path", { xmlns: "http://www.w3.org/2000/svg", d: "M240-200v-680h560v680zm60-60h440v-560H300zM120-80v-680h60v620h500v60zm180-180v-560z" })));
}
